import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SipOpportunityListComponentPage } from './sip-opportunity-list-component.page';
import { ButtonModule } from 'common/components/button/button.module';
import { NumberFormatModule } from 'common/pipe/numberFormat/number-format.module';
import { NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormErrorModule } from 'common/components/form-error/form-error.module';
import { NoDataFoundModule } from 'common/components/no-data-found/no-data-found.module';

@NgModule({
    declarations: [SipOpportunityListComponentPage],
    imports: [CommonModule, IonicModule, FormsModule, ButtonModule, NumberFormatModule, ReactiveFormsModule, NgbPaginationModule, FormErrorModule, NoDataFoundModule, NgbTooltipModule],
    exports: [SipOpportunityListComponentPage],
})
export class SipOpportunityListComponentPageModule {}
